import request from 'assets/js/http';

export function roleList(data) {
  // 获取角色列表
  return request({
    url: '/role/list',
    method: 'post',
    data
  });
}
export function roleAction(data) {
  // 新增-修改 角色
  let url = '/role/add';
  if (data.id || data.id === 0) {
    url = '/role/edit';
  }
  return request({
    url: url,
    method: 'post',
    data
  });
}
export function roleDelete(data) {
  // 角色删除
  return request({
    url: '/role/delete',
    method: 'post',
    data
  });
}
export function roleDataPermissionList(id) {
  //数据权限列表接口
  return request({
    url: '/dataPermission/editRole',
    method: 'post',
    data: { roleId: id }
  });
}

export function saveDataPermission(data) {
  // 保存数据权限
  return request({
    url: '/dataPermission/saveRole',
    method: 'post',
    data
  });
}
export function roleMenuPermissionList(id) {
  //菜单权限列表接口
  return request({
    url: '/role/functionPermissionGet',
    method: 'post',
    data: { roleId: id }
  });
}
export function setRoleMenuPermission(data) {
  //保存权限列表接口
  return request({
    url: '/role/functionPermissionUpdate',
    method: 'post',
    data
  });
}
